import _entries from 'lodash/entries';
import _flatMap from 'lodash/fp/flatMap';
import _pipe from 'lodash/fp/pipe';
import _values from 'lodash/values';

const createAdjustmentDataPoint = (adjustment) => {
  return _entries(adjustment)
    .filter((entry) => entry[0] !== 'active')
    .map((entry) => ({
      active: adjustment.active,
      compositeKey: entry[0],
      adjustmentAmount: entry[1],
    }));
};

export const extractAdjustmentLines = (updatedAdjustmentType) => {
  const adjustmentLines = _pipe(
    _values,
    _flatMap(_values),
    _flatMap(createAdjustmentDataPoint)
  )(updatedAdjustmentType);

  return adjustmentLines;
};
